// src/App.js

import React, { useState } from 'react';
import { Container, Box } from '@mui/material';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import Header from './components/Header';
import AddContracts from './pages/Hilfsmittel/AddContracts'; // ✅ NEU
import ScannerPage from './pages/Scann/SannerPage';
import Vertragsrichtlinien from './pages/Hilfsmittel/VertragsrichtlinienPage'
import ScannerSettingsPage from './pages/ScannerSettingsPage'
import MesseDemoPage from './pages/Messe/MesseDemoPage.js'
import MesseScreenHR from './pages/Messe/MesseScreenHR.js'
import VoCheckerPage from './pages/Hilfsmittel/VoCheckerPage';

function App() {
  const navigate = useNavigate();

  const theme = createTheme({
    palette: {
      primary: {
        main: '#6100FF', // Blau
      },
      secondary: {
        main: '#C0FF00', // Pink
      },
    },
  });

  const handleHomeClick = () => {
    navigate("/home");
  };

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Header onHomeClick={handleHomeClick} />
        <Container sx={{ marginTop: 2 }}>
          {/* {content} */}
          {/* Alternativ über Routes, wenn du react-router nutzt: */}
          <Routes>
            <Route path="/home" element={<Box />} />
            <Route path="/scanner" element={<ScannerPage />} />
            <Route path="/vertraege" element={<AddContracts />} />
            <Route path="/richtlinienAnzeigen" element={<Vertragsrichtlinien />} />
            <Route path="/options" element={<ScannerSettingsPage />} />
            <Route path="/vochecker" element={<VoCheckerPage />} />
            <Route path="/messeDemoPage" element={<MesseDemoPage />} />
            <Route path="/messeScreenHR" element={<MesseScreenHR />} />
            <Route path="/" element={<MesseDemoPage />} />
          </Routes>
        </Container>
      </div>
    </ThemeProvider>
  );
}

export default App;
